module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "img8",
      "src": "images/img8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Program for the United Indian War Veterans’ observance of the sixtieth anniversary of the “Custer Massacre” on June 25, 1936, in Balboa Park, San Diego, California. During the exercises, Mrs. Ora McClinton offered a telling of “How My Husband Recovered Custer’s Battle Flag” at the Little Bighorn."), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Editor’s collection.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2b10570","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndianWarVeterans_introduction13.vue
// module id = 117
// module chunks = 0